import { Navigate } from 'react-router-dom';
import useUserStore from '../../stores/useUserStore';

/**
 * Route guard for gateable modules (Phase 1 re-center).
 * Renders `children` when the module is enabled, else redirects home.
 * Core surfaces (Today/Focus/Circuits/Logs/Tasks/Capture) are never wrapped.
 */
export default function ModuleRoute({ module, children }) {
    const isModuleEnabled = useUserStore(s => s.isModuleEnabled);
    if (!isModuleEnabled(module)) {
        return <Navigate to="/" replace />;
    }
    return children;
}
